import React from 'react'
import { ThemeToggler } from 'gatsby-plugin-dark-mode'
import './theme-toggler.css'
import { FaMoon } from 'react-icons/fa'
import {BsFillSunFill} from "react-icons/bs"

export const ToggleBtn = () => (
    <ThemeToggler>
        {({ theme, toggleTheme }) => {
            return (
                <button
                aria-label="Toggle Dark Mode"
                type="button"
                className="block lg:inline-flex p-3 h-12 w-12 sm:order-2 md:order-3"
                onClick={() => toggleTheme(theme === 'dark' ? 'light' : 'dark')}>
                {theme === "dark" ? <BsFillSunFill color="orange"/> : <FaMoon color="blue"/>}
                </button>
            )
        }}
    </ThemeToggler>
)